import clsx from "classnames";
import classes from "./styles.module.scss";
import Address from "@/assets/Address.svg";
import Phone from "@/assets/Phone.svg";
import Email from "@/assets/Email.svg";
import { DynamicText } from "@/components/DynamicText";
import { getGlobal } from "@/getters/getGlobal";

export const GetInTouch = ({ className }) => {
  const global = getGlobal();

  return (
    <div className={clsx(className, classes.getintouch)}>
      <h3 className="text-white">Get in Touch</h3>
      <dl>
        <dt>
          <Address />
          <span className="visually-hidden">Address</span>
        </dt>
        <dd>
          <DynamicText path="contact.details.address.inline" />
        </dd>
      </dl>
      <div>
        <dl>
          <dt>
            <Phone />
            <span className="visually-hidden">Phone</span>
          </dt>
          <dd>
            <a href={`tel:${global["contact.details.phone"]}`}>
              <DynamicText path="contact.details.phone" />
            </a>
            <p className="small">
              All calls are recorded for training and quality purposes. Full details are available in our Privacy
              Policy.
            </p>
          </dd>
        </dl>
      </div>
      <dl>
        <dt>
          <Email />
          <span className="visually-hidden">Email</span>
        </dt>
        <dd>
          <a href={`mailto:${global["contact.details.email"]}`}>
            <DynamicText path="contact.details.email" />
          </a>
        </dd>
      </dl>
    </div>
  );
};
